import i18n from 'client/i18n'
import { createContainerStructure } from 'client/utils/createStructureUtils'
import { ButtonInterface } from 'common/types/entities/button-interface'
import { OldEntityWithChildIds } from 'common/types/entities/OldEntityInterface'
import { createButtonNew } from 'src/shared/entities/button/create-button'
import { insertChild } from 'src/shared/entities/utils/generate-base-entity'
import { ContainerBaseEntityUnionInterface } from 'src/shared/schemas/container-base-entity.schema'

export const createButtonFromLibrary = ({
  container,
  locale,
  position = 0,
  options,
  createButton = createButtonNew,
}: {
  container: ContainerBaseEntityUnionInterface | OldEntityWithChildIds
  locale: string
  position?: number
  options?: Partial<ButtonInterface>
  createButton?: typeof createButtonNew
}) => {
  const fixedT = i18n.getFixedT(locale)

  const { structure, descendantEntity } = createContainerStructure(
    container,
    locale,
    position,
  )

  const button = createButton(
    descendantEntity.id,
    fixedT('entities.button.default_text'),
    fixedT('entities.button.default_sub_text'),
    descendantEntity.masterBlockId,
  )

  return {
    ...structure,
    [descendantEntity.id]: {
      ...descendantEntity,
      childIds: insertChild(descendantEntity.childIds, button.id, position),
    },
    [button.id]: {
      ...button,
      ...options,
    },
  }
}
